import { SplitPanel } from '@cloudscape-design/components';
import { useAuthContext } from '../contexts/AuthContext';
import { changes } from '../data/changes';
import Loginout from '../layout/Loginout';
import version from '../v.json';

const ChangesPanel = () => {
  const { userObject } = useAuthContext();

  return (
    <SplitPanel
      header={`${userObject?.name ?? ''}${userObject?.name ? ' - ' : ''}The Horrible Meadery © 2025 - ${
        version.MajorMinorPatch + '.' + version.CommitsSinceVersionSource
      }`}
      hidePreferencesButton
    >
      {userObject ? (
        <>
          <p>Latest changes:</p>
          <ul>
            {changes.map((change) => (
              <li key={change.title}>
                <strong>{change.title}</strong>
                <br />
                {change.description}
                <br />- <small>({change.note})</small>
              </li>
            ))}
          </ul>
        </>
      ) : (
        <Loginout />
      )}
    </SplitPanel>
  );
};

export default ChangesPanel;
